import type { RecordingRecord } from './api'

/** One bounded History page; later pages require an explicit user action. */
export const STATE_HISTORY_PAGE_SIZE = 50

/** The loaded, same-cohort dates State may show. Home owns the anchor identity. */
export function stateRecentRows(
  anchor: RecordingRecord,
  loaded: readonly RecordingRecord[],
  selectedId: string,
): RecordingRecord[] {
  const byDate = new Map<string, RecordingRecord>()
  for (const row of loaded) {
    if (row.status !== 'scored' || row.condition !== anchor.condition
      || row.device_id !== anchor.device_id || row.session_date >= anchor.session_date) continue
    const held = byDate.get(row.session_date)
    if (held === undefined || row.recording_id > held.recording_id) byDate.set(row.session_date, row)
  }

  // A newly loaded same-day winner must not silently change the selected ID.
  const selected = loaded.find((row) => row.recording_id === selectedId)
  if (selected !== undefined && byDate.has(selected.session_date)) byDate.set(selected.session_date, selected)

  const before = [...byDate.values()].sort((a, b) => a.session_date.localeCompare(b.session_date))
  let prior = before.slice(-6)
  if (selected !== undefined && byDate.has(selected.session_date) && !prior.some((row) => row.recording_id === selectedId)) {
    prior = [...prior.slice(1), selected].sort((a, b) => a.session_date.localeCompare(b.session_date))
  }
  return [...prior, anchor]
}
